import ItemModel from "../../model2/item/item-model"
import FieldProto from "./field-proto"
import TableManager from "../../gd-modules/table/manager/table-manager"
import TaskListManager from "../../gd-modules/task-list/manager/manager"
import {CustomFieldScope} from "../../gd/const/fields/custom-fields-v1-const";

export enum FieldFilterType {
    DROPDOWN_DYNAMIC    = 'dropdown-dynamic', // use this one when we need options filler - i.e. project filter we need to extract all options from our collection (!)
    DROPDOWN            = 'dropdown',
    STRING              = 'string',
    NUMBER              = 'number',
    MULTISELECT         = 'multiselect',
    BOOLEAN             = 'boolean',
    DATE                = 'date',
    RATING              = 'rating',
    USER                = 'user',
    RAG                 = 'rag'
}


export type FieldRenderOptions = {


    displayIcon?            : boolean   // used in Schedule eitable - show icons task view mode


}

export type FieldParams = {

    // Date
    highlightIfPastdue?         : boolean

    // Table Cell
    tableCellOnValueChange?     : ( item:ItemModel, value:any, manager : TableManager|TaskListManager ) => void
    tableCellOnAdd?             : {(item:ItemModel):void}

    scope?                      : CustomFieldScope[]    // used when we use Field3 as CustomFieldV1 (tasks/projects()

    voteIcon?                   : number // from All Reactions

    popoverClassName?           : string // is used to set class name for dropdown PopoverMenu
}


export type FieldClasses = {

    PopoverMenu?        : string,
    PopoverMenuScrollContainer?     : string
    inlineValueClass?           : string
}



export type FieldRenderComponents = {
    view                    : any,  // default view
    viewSmall               : any,  // smaller view ... used in glist, etc.

    viewReference           : any,  // used in ItemView when need to specify task/project etc. without editing but with click action as a control button (see fieldType.TASK)
    viewProperty            : any,  // ui5 property i.e. board card, or list project name

    // Deprecated ???
    inlineEditable          : any,
    inlineEditableSmall     : any, // like inline editable but got glist/list/table usage

    // Experimental new this is true editable component, with SIZE support, used in inlineEditable and tableEditable etc.,
    // doesnt check access i.e. if u use it it is editable
    editable                : any,

    picker                  : any, // small icon + popover

    formElement             : any,
    formElementView         : any,

    managementPreview       : any, // Custom field settings
    managementForm          : any, // Custom field settings
    managementFormCFV1      : any, // Custom field for tasks and projects (gd.session.customFields)

    quickFilterView         : any,  // Task list left ?
    csvImportPreview        : any,

    // GLIST
    glistView               : any,
    glistEditable           : any,
    glistGroup              : any,

    // TABLE (use either tableCell OR View/Editable?)
    tableCell               : any,  // po hodu this is whole cell
    // tableView               : any,  // just content inside table cell view only
    // tableEditable           : any,  // content inside table cell editable

    // TASK LIST
    tlistView               : any,
    tlistEditable           : any,

    // AUTOMATIONS
    automationTriggerForm   : any,
    automationConditionForm : any,
    automationActionForm    : any,

    conditionForm           : any,

    // GRAPHS
    graphTickLabelView      : any,
    graphTooltipView        : any,

    goalListEditable?       : any
    goalListView?           : any

    controlView?            : any
}


export type FieldComponents = {

    // glist special
    glistGroupModern?       : any,
    glistGroupStandard?     : any,

    // Icon
    ValueIcon?              : any
    ValuePrefix?            : any // is it in use ?

    // inline editable
    InlineValueEmpty?       : any
    InlineValueNotEmpty?    : any

    ListValueEmpty?         : any
    ListValueNotEmpty?      : any

    // dropdown menus
    PopoverMenu?            : any
    PopoverMenuMore?        : any   // used to help hint etc in popover on the bottiom like edit expense categories, view for etc
    PopoverOption?          : any

    PickerValueEmpty?       : any
    PickerValueNotEmpty?    : any

    FormValueEmpty?         : any
    FormValueNotEmpty?      : any
    Pill?                   : any

    // Control view
    ControlViewEmpty?       : any
    ControlViewNotEmpty?    : any

}


export type FieldPopoverProps = {
    parent      : any  //FieldPopover_FormComponent | FieldPopover_InlineEditable, // can be other like inline edit etc.
    field       : FieldProto
    value       : any
    model?      : any
    className?  : string
    disabled?   : boolean
    onChange    : callback,
    targetOffset?   : any,
    options?    : any
};
